module.exports = __webpack_public_path__ + "img/fondo-banner-principal.a64932af.png";